import React, { useEffect } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Avatar,
  Box,
  IconButton,
  Menu,
  MenuItem,
  Button,
  Divider
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import AddIcon from '@mui/icons-material/Add';
import paybito from "../Assets/paybito.png";
import CryptoJS from "crypto-js";
import { tokenCookie, logoutUser } from '../SystemHandler/AuthRedirectHandler';

// Import or define your images
import homeIcon from "../Assets/paybito.png"; // Add your icons
import marketplaceIcon from "../Assets/teamupsLogo.png";
import commerceIcon from "../Assets/marketPlaceLogo.png";
import appStoreIcon from "../Assets/paybitoLogo.png";

import PersonIcon from '@mui/icons-material/Person';

const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;

const Navbar = ({ onMenuClick }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [balance, setBalance] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  const open = Boolean(anchorEl);

  // Navigation items data with icons
  const navItems = [
    {
      label: 'BitoCircle Home',
      href: `https://bitocircle.com?app=${encodeURIComponent(localStorage.getItem('appData'))}`,
      icon: homeIcon
    },
    {
      label: 'Token Marketplace',
      href: 'https://bitocircle.com/token-marketplace',
      icon: marketplaceIcon
    },
    {
      label: 'Crypto Commerce',
      href: 'https://bitocircle.com/crypto-commerce',
      icon: commerceIcon
    },
    {
      label: 'App Store',
      href: `https://apps.paybito.com?app=${encodeURIComponent(localStorage.getItem('appData'))}`,
      icon: appStoreIcon
    }
  ];

  const handleAvatarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  /**
   * Encrypt user data to send to App Store
   */
  const encryptUserDataForAppStore = () => {
    try {
      const token = tokenCookie.get();
      const brokerId = localStorage.getItem('brokerId');
      const userId = localStorage.getItem('userId');
      const uuid = localStorage.getItem('uuid');

      if (!token || !brokerId || !userId) {
        console.error('[AppStore] Missing required user data');
        return null;
      }

      const dataToEncrypt = {
        token: token,
        adminUsersResult: {
          brokerId: brokerId,
          uuid: uuid,
          user_id: parseInt(userId, 10),
        },
      };

      const jsonString = JSON.stringify(dataToEncrypt);
      const encrypted = CryptoJS.AES.encrypt(jsonString, SECRET_KEY).toString();
      const urlEncoded = encodeURIComponent(encrypted);

      return urlEncoded;
    } catch (error) {
      console.error('[AppStore] Error encrypting data:', error);
      return null;
    }
  };

  const handleNavClick = (item, event) => {
    if (item.label === 'App Store') {
      event.preventDefault();
      const encryptedData = encryptUserDataForAppStore();
      if (encryptedData) {
        window.open(`${item.href}?app=${encryptedData}`, '_blank');
      } else {
        window.open(item.href, '_blank');
      }
    }
  };

  const handleLogout = async () => {
    handleCloseMenu();
    const success = await logoutUser();
    if (success) {
      window.location.href = 'https://myaccount.paybito.com/signin?continue=https%3A%2F%2Fad-center.bitocircle.com%2F&app=AdCenter';
    }
  };

  const fetchUserBalance = async () => {
    setLoading(true);
    try {
      const token = tokenCookie.get() || localStorage.getItem('access_token_us');
      const response = await fetch('https://institutional-bo.paybito.com:8443/BrokerAdminApi/finance-hub/getUserBalance', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'authorization': `bearer ${token}`,
        },
        body: JSON.stringify({
          adminUser: localStorage.getItem('uuid') || "da9a2f00-7b37-11ef-b806-ad63e6a7004c",
          userUuid: localStorage.getItem('financeHubUuid') || "9afb0d77-0584-4b51-983c-09eb42334fc5"
        })
      });

    const data = await response.json();

    // Find USDB currency balance
    const usdbBalance = data.userBalanceList?.find(
      currency => currency.currencyCode === 'USDB'
    );

    if (usdbBalance) {
      setBalance(usdbBalance.closingBalance);
    }
  } catch (error) {
    console.error('Error fetching balance:', error);
  } finally {
    setLoading(false);
  }
};

  const handleAddFunds = () => {
    // Get app value from localStorage
    const appval = localStorage.getItem('appData');

    // Construct URL with app parameter
    const url = `https://bitocircle.com/bitodollar-wallet?app=${encodeURIComponent(appval)}`;

    // Open BitoDollar wallet in new tab
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  useEffect(() => {
    fetchUserBalance();
  }, []);

  return (
    <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
      <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
        {/* Left: App Logo */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {/* Mobile menu button */}
          <IconButton
            color="inherit"
            onClick={onMenuClick}
            sx={{ display: { md: 'none' } }}
            aria-label="open drawer"
          >
            <MenuIcon />
          </IconButton>
          <img
            src={paybito}
            alt="App Logo"
            style={{ width: 40, marginRight: 10 }}
          />
          <Typography variant="h6" noWrap>
            BitoCircle Ad Center
          </Typography>
        </Box>

        {/* Center: Navigation Links with Icons */}
        <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 2 }}>
          {navItems.map((item) => (
            <Button
              key={item.label}
              color="inherit"
              component="a"
              href={item.href}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(event) => handleNavClick(item, event)}
              sx={{
                textTransform: 'none',
                fontSize: '0.9rem',
                fontWeight: 400,
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.1)'
                }
              }}
            >
              {/* Icon before text */}
              {item.icon && (
                <img
                  src={item.icon}
                  alt={item.label}
                  style={{
                    width: '20px',
                    height: '20px',
                    marginRight: '8px',
                  }}
                />
              )}
              {item.label}
            </Button>
          ))}
        </Box>

        {/* Right: Balance, Add Funds, and Avatar */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          {/* Balance Display - Professional Style */}
          <Box
            sx={{
              display: { xs: 'none', sm: 'flex' },
              alignItems: 'center',
              gap: 0.5
            }}
          >
            <Typography
              variant="body2"
              sx={{
                color: 'rgba(255, 255, 255, 0.8)',
                fontWeight: 400,
                fontSize: '0.875rem'
              }}
            >
              Your Balance
            </Typography>
            <Typography
              variant="h6"
              sx={{
                color: 'white',
                fontWeight: 600,
                fontSize: '1.1rem',
                letterSpacing: '0.02em'
              }}
            >
              {loading ? '...' : `B$${balance.toFixed(2)}`}
            </Typography>
          </Box>

          {/* Divider */}
          <Divider
            orientation="vertical"
            flexItem
            sx={{
              display: { xs: 'none', sm: 'block' },
              backgroundColor: 'rgba(255, 255, 255, 0.2)',
              height: '32px',
              alignSelf: 'center'
            }}
          />

          {/* Add Funds Button */}
          <Button
            variant="contained"
            color="primary"
            size="medium"
            startIcon={<AddIcon />}
            onClick={handleAddFunds}
            sx={{
              display: { xs: 'none', sm: 'flex' },
              textTransform: 'none',
              fontWeight: 600,
              px: 2.5,
              py: 0.75,
              borderRadius: 1.5,
              boxShadow: 'none',
              '&:hover': {
                boxShadow: 2
              }
            }}
          >
            Add Funds
          </Button>

          {/* Avatar */}
          <IconButton onClick={handleAvatarClick}>
            <Avatar
              alt="User"
              src={localStorage.getItem('profilePhoto') || undefined}
              sx={{ bgcolor: 'white' }}
            >
              <PersonIcon />
            </Avatar>
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleCloseMenu}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
          >
            <MenuItem onClick={handleLogout}>Logout</MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;